import socketClient from 'socket.io-client';

type io = (namespace: string) => typeof socketClient.Socket;

export function* emitSocketForceCompleteLesson(courseId: number, clessonId: number, io: io, websocketDomain?: string) {
    const socket = io(websocketDomain ? `${websocketDomain}/courses` : '/courses');
    socket.on('connect', () => {
        socket.emit('forceCompleteLesson', { courseId, clessonId });
        socket.close();
    });
}
